module.exports = __webpack_public_path__ + "static/media/WorkoutRestDay.fb16c077.png";